import { getFeatureToggleClient } from 'infra/featureToggles'

export default function isDocumentVersionsTabDisabled(): boolean {
  return getFeatureToggleClient().variation(
    'Portals.DisableDocumentVersionTab',
    false,
  )
}
